import React from 'react';
import TopBar from './TopBar';

function TopBarWithSignUp({ children }) {
  return (
    <React.Fragment>
      <TopBar logoOnly position="fixed" brandTo="/" />
      <div>{children}</div>
    </React.Fragment>
  );
}

export default TopBarWithSignUp;
